<template>
  <div class="page">
    <div class="info">
      <van-icon name="arrow-left" class="back" @click="goBack" />
    </div>
    <el-tabs :stretch="true" v-model="activeName" @tab-click="handleClick" class="tabs fill_tabs_box">
      <el-tab-pane label="院校优先" name="college">
        <van-dropdown-menu>
          <van-dropdown-item v-for="(item, i) in filterOption" :key="i" :title="item.name" :ref="'item_' + i">
            <div class="filter-list">
              <div class="filter-list-title">{{ item.name }}</div>
              <div class="filter-list-tags">
                <div class="tag">
                  <div class="tag_box" :class="filterData[item.type].length === 0 ? 'active' : ''"
                    @click="filterClick(i, -1)">
                    不限
                    <i v-if="filterData[item.type].length === 0" class="el-icon-check tag_icon"></i>
                  </div>
                </div>
                <div class="tag" v-for="(tag, t) in item.list" :key="t">
                  <div class="tag_box" v-if="tag.name == '新增院校' || tag.name == '非新增院校'"
                    :class="tag.isChecked ? 'active' : ''" @click="filterClick(i, t, 'newCollege')">
                    {{ tag.name }}
                    <i v-if="tag.isChecked" class="el-icon-check tag_icon"></i>
                  </div>
                  <div class="tag_box" v-else :class="tag.isChecked ? 'active' : ''" @click="filterClick(i, t)">
                    {{ tag.name }}
                    <i v-if="tag.isChecked" class="el-icon-check tag_icon"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="filter-action">
              <button class="van-button van-button--primary van-button--large" @click="clickFillBtn(i)">
                确定
              </button>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
        <div class="filter-list pb20" style="border: none">
          <span style="display: none" class="filter-list-title">意向院校</span>
          <div class="filter-list-tags search_box">
            <el-autocomplete v-model="filterData.keyword" prefix-icon="el-icon-search" :fetch-suggestions="search"
              placeholder="请输入意向院校" clearable @select="handleSelect">
              <template slot-scope="{ item }">
                <div class="name" v-html="highLightText(item.value, filterData.keyword)"></div>
              </template>
            </el-autocomplete>
            <!--                  <el-input prefix-icon="el-icon-search" v-model="filterData.keyword" placeholder="请输入意向院校"-->
            <!--                  clearable></el-input>-->
          </div>
        </div>

        <div class="myFilterRecordBlockRow" v-if="false">
          <div class="customer-selected-tags">
            <span class="fz-14 f-col" style="color: #9b9b9b">
              <span>筛选条件:</span>
              <el-button v-if="filterDataArr > 0" style="margin-left: -5px" type="text" size="mini"
                @click="clearJobFilterData">清空</el-button>
            </span>
            <div class="tags" style="min-height: 40px; margin-left: 4px">
              <span class="tag" v-for="tag in filterDataArr">
                <i class="iconfont icon-pcyuanxiao fz-14" style="color: rgb(102, 102, 102)"></i>
                {{ tag.name }}
                <i class="el-icon-close" @click="removeItem(tag)"></i>
              </span>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="专业优先" name="major">
        <van-dropdown-menu>
          <van-dropdown-item title="专业选择" ref="item_21">
            <div class="filter-list">
              <div class="filter-list-title">专业选择</div>
              <div class="filter-list-tags">
                <div class="tag" v-for="(tag, i) in majorFilterOption.features" :key="i">
                  <div class="tag_box" :class="tag.isChecked ? 'active' : ''" @click="changeMajorType(tag.name)">
                    {{ tag.name }}
                    <i v-if="tag.isChecked" class="el-icon-check tag_icon"></i>
                  </div>
                </div>
              </div>
              <div class="filter-list-title">专业选择</div>
              <div class="filter-list-tags">
                <div class="tag">
                  <div class="tag_box" :class="majorFilterData['majorList'].length === 0 ? 'active' : ''
        " @click="majorFilterClick(-1, 'majorList')">
                    不限({{ majorList.list.length }})
                    <i v-if="majorFilterData['majorList'].length === 0" class="el-icon-check tag_icon"></i>
                  </div>
                </div>
              </div>
              <div class="fill_tabs_box_tags">
                <van-sidebar v-model="activeMajorKey">
                  <van-sidebar-item v-for="(tag, i) in majorList.list" :title="tag.name + '(' + tag.major.length + ')'"
                    :key="i" />
                </van-sidebar>
                <div class="right_box">
                  <div class=" filter-list-tags1">
                    <div style="width: auto" v-for="(item, index) in majorList.list[activeMajorKey] &&
        majorList.list[activeMajorKey].major" :key="index">
                      <span class="tag1_title" :class="majorFilterData.majorList.filter(
        (e) => e.name == item.name
      ).length > 0
          ? 'active1'
          : ''
        ">
                        {{ item.name }}
                      </span>

                      <div class="filter-list-tags">
                        <div v-for="(ele, index) in item.major" :key="index" class="tag">
                          <div class="tag_box" style="padding: 0 10px" :class="majorFilterData.majorList.filter(
        (e) => e.name == ele.name
      ).length > 0
          ? 'active'
          : ''
        " @click="setMajorFilter(ele)">
                            {{ ele.name }}
                            <i v-if="majorFilterData.majorList.filter(
        (e) => e.name == ele.name
      ).length > 0
        " class="el-icon-check tag_icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="filter-action">
              <button class="van-button van-button--primary van-button--large" @click="clickFillBtn1(21)">
                确定
              </button>
            </div>
          </van-dropdown-item>
          <van-dropdown-item :title="majorFilterOption.majorType.name" ref="item_22">
            <div class="filter-list">
              <div class="filter-list-title">
                {{ majorFilterOption.majorType.name }}
              </div>
              <div class="filter-list-tags">
                <div class="tag">
                  <div class="tag_box" :class="majorFilterData.majorType.length === 0 ? 'active' : ''
        " @click="majorFilterClick(-1, 'majorType')">
                    不限
                    <i v-if="majorFilterData.majorType.length === 0" class="el-icon-check tag_icon"></i>
                  </div>
                </div>
                <template v-for="(tag, index) in majorFilterOption.majorType.list">
                  <div class="tag" v-if="tag.name == '新增专业' || tag.name == '非新增专业'">
                    <div class="tag_box" :class="tag.isChecked ? 'active' : ''"
                      @click="majorFilterClick(index, 'newMajor')">
                      {{ tag.name }}
                      <i v-if="tag.isChecked" class="el-icon-check tag_icon"></i>
                    </div>
                  </div>
                  <div class="tag" v-else>
                    <div class="tag_box" :class="tag.isChecked ? 'active' : ''"
                      @click="majorFilterClick(index, 'majorType')">
                      {{ tag.name }}
                      <i v-if="tag.isChecked" class="el-icon-check tag_icon"></i>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="filter-action">
              <button class="van-button van-button--primary van-button--large" @click="clickFillBtn1(22)">
                确定
              </button>
            </div>
          </van-dropdown-item>
          <van-dropdown-item :title="majorFilterOption.cost.name" ref="item_23">
            <div class="filter-list">
              <div class="filter-list-title">
                {{ majorFilterOption.cost.name }}
              </div>
              <div class="filter-list-tags">
                <div class="tag">
                  <div class="tag_box" :class="majorFilterData.cost.length === 0 ? 'active' : ''"
                    @click="costFilterClick(-1, 'cost')">
                    不限
                    <i v-if="majorFilterData.cost.length === 0" class="el-icon-check tag_icon"></i>
                  </div>
                </div>
                <template v-for="(tag, index) in majorFilterOption.cost.list">
                  <div class="tag" style="width: auto">
                    <div class="tag_box" :class="tag.isChecked ? 'active' : ''" @click="costFilterClick(index)"
                      style="padding: 0 12px">
                      {{ tag.name }}
                      <i v-if="tag.isChecked" class="el-icon-check tag_icon"></i>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="filter-action">
              <button class="van-button van-button--primary van-button--large" @click="clickFillBtn1(23)">
                确定
              </button>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
        <div class="filter-list pb20" style="border: none">
          <span class="filter-list-title" v-if="false">意向专业</span>
          <div class="filter-list-tags search_box">
            <el-autocomplete v-model="majorFilterData.keyword" prefix-icon="el-icon-search" :fetch-suggestions="search"
              :trigger-on-focus="false" placeholder="请输入意向专业" clearable select-when-unmatched @select="handleSelect">
              <template slot-scope="{ item }">
                <div class="name" v-html="highLightText(item.value, majorFilterData.keyword)"></div>
              </template>
            </el-autocomplete>
            <!--                  <el-input prefix-icon="el-icon-search" v-model="filterData.keyword" placeholder="请输入意向院校"-->
            <!--                  clearable></el-input>-->
          </div>
          <span class="filter-list-title m-r-15 m-l-30" v-if="false">用户测评</span>
          <div style="z-index: 3; padding: 15px 15px 0px" class="search_box1">
            <el-select style="width: 100%" v-model="userEvaluation" value-key="value" collapse-tags multiple
              placeholder="请选择用户测评" @change="handleSelectMajor">
              <el-option v-for="item in majorTestList" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="myFilterRecordBlockRow" v-if="false">
          <div class="customer-selected-tags">
            <span class="fz-14 f-col" style="color: #9b9b9b">
              <span>筛选条件:</span>
              <el-button v-if="filterDataArr.length > 0" style="margin-left: -5px" type="text" size="mini"
                @click="clearJobFilterData">清空</el-button>
            </span>
            <div class="tags" style="min-height: 40px; margin-left: 4px">
              <span class="tag" v-for="tag in filterDataArr">
                <i class="iconfont icon-pcyuanxiao fz-14" style="color: rgb(102, 102, 102)"></i>
                {{ tag.name }}
                <i class="el-icon-close" @click="removeItem(tag)"></i>
              </span>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="职业优先" name="job">
        <van-dropdown-menu class="job">
          <van-dropdown-item title="职业选择" ref="item_31">
            <div class="filter-list">
              <div class="filter-list-title">职业选择</div>
              <div class="filter-list-tags">
                <div class="tag">
                  <div class="tag_box" :class="jobFilterData['jobList'].length === 0 ? 'active' : ''
        " @click="jobFilterClick(-1, 'jobList')">
                    不限({{ jobFilterOption.jobList.list.length }})
                    <i v-if="jobFilterData['jobList'].length === 0" class="el-icon-check tag_icon"></i>
                  </div>
                </div>
              </div>
              <div class="fill_tabs_box_tags">
                <van-sidebar v-model="activeJobKey">
                  <van-sidebar-item v-for="(tag, i) in jobFilterOption.jobList.list"
                    :title="tag.name + '(' + tag.jobs.length + ')'" :key="i" />
                </van-sidebar>
                <div class="right_box">
                  <div class="filter-list-tags">
                    <div class="tag" style="width: auto" v-for="(item, index) in jobFilterOption.jobList.list[
        activeJobKey
      ] && jobFilterOption.jobList.list[activeJobKey].jobs" :key="index">
                      <div class="tag_box" style="padding: 0 10px" :class="jobFilterData.jobList.filter(
        (e) => e.name == item.name
      ).length > 0
          ? 'active'
          : ''
        " @click="setJobFilter(item)">
                        {{ item.name }}
                        <i v-if="jobFilterData.jobList.filter(
        (e) => e.name == item.name
      ).length > 0
        " class="el-icon-check tag_icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="filter-action">
              <button class="van-button van-button--primary van-button--large" @click="clickFillBtn1(31)">
                确定
              </button>
            </div>
          </van-dropdown-item>
          <van-dropdown-item> </van-dropdown-item>
          <van-dropdown-item> </van-dropdown-item>
        </van-dropdown-menu>

        <div class="filter-list pb20" style="border: none">
          <span class="filter-list-title" v-if="false">意向职业</span>
          <div class="filter-list-tags search_box">
            <el-autocomplete v-model="jobFilterData.keyword" prefix-icon="el-icon-search" :fetch-suggestions="search"
              :trigger-on-focus="false" placeholder="请输入意向职业" value-key="name" clearable @select="handleSelect">
              <template slot-scope="{ item }">
                <div class="name" v-html="highLightText(item.value, jobFilterData.keyword)"></div>
              </template>
            </el-autocomplete>
          </div>
        </div>
        <div class="myFilterRecordBlockRow" v-if="false">
          <div class="customer-selected-tags">
            <span class="fz-14 f-col" style="color: #9b9b9b">
              <span>筛选条件:</span>
              <el-button v-if="filterDataArr.length > 0" style="margin-left: -5px" type="text" size="mini"
                @click="clearJobFilterData">清空</el-button>
            </span>
            <div class="tags" style="min-height: 40px; margin-left: 4px">
              <span class="tag" v-for="tag in filterDataArr">
                <i class="iconfont icon-pcyuanxiao fz-14" style="color: rgb(102, 102, 102)"></i>
                {{ tag.name }}
                <i class="el-icon-close" @click="removeItem(tag)"></i>
              </span>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <div class="myFilterRecordBlockRow">
        <div class="score-range-wrapper">
          <div class="score-range">
            <div class="score-box score-box1">
              <span class="m-r-30">高级筛选</span>
              <div>
                <p>
                  <el-checkbox :label="item" v-for="(item, index) in planConfig.course" :key="index"
                    v-model="chooseSubject" @change="highFilter($event, item)"></el-checkbox>
                </p>
              </div>
            </div>
            <div class="score-box" v-if="false">
              <span class="m-r-30">推荐范围</span>
              <div class="slider">
                <vue-slider v-model="sliderValue" :lazy="true" tooltip="none" :processStyle="{ background: '#910000' }"
                  direction="rtl" :min="planConfig.minScore" :max="planConfig.maxScore" @change="handleSliderChange">
                  <template v-slot:dot="{ value }">
                    <div>
                      <span style="background-color: #910000;padding: 1px 10px;color: #fff;border-radius: 10px">{{ value
                        }}</span>
                    </div>
                  </template>
                </vue-slider>
                <!-- <el-slider
                    v-model="sliderValue"
                    range
                    :max="planConfig.maxScore"
                    :min="planConfig.minScore"
                    @change="handleSliderChange"
                    :marks=[max,min]
                  >
                  </el-slider> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="myFilterRecordBlockRow" v-if="filterDataArr.length > 0">
        <div class="fill_box_title" style="display: flex; justify-content: space-between; align-items: center">
          <span>筛选条件:</span>
          <el-button v-if="filterDataArr.length > 0" style="margin-left: -5px" type="text" size="mini"
            @click="clearJobFilterData">清空</el-button>
        </div>
        <div class="customer-selected-tags">
          <div class="tag" v-for="(tag, index) in filterDataArr" :key="index">
            <i class="iconfont icon-pcyuanxiao fz-14" style="color: rgb(102, 102, 102)"></i>
            {{ tag.name }}
            <i class="el-icon-close" @click="removeItem(tag)"></i>
          </div>
        </div>
      </div>
    </el-tabs>

    <div class="foot-box van-row">
      <div class="foot-box-a">
        <a href="javascript:void(0)" class="text-center f14 color-666" style="flex: 1 1 0%">
          已填
          <span class="filled">{{ filterDataArr.length }}</span>
          个
        </a>
      </div>
      <div class="recommendBtn-flex-flex">
        <button @click="setFillData" class="recommend-btn van-button van-button--primary van-button--large">
          <div class="van-button__content">
            <span class="van-button__text">
              完成设置
            </span>
          </div>
        </button>
      </div>
    </div>
    <el-dialog title="创建成绩" :visible.sync="dialogVisible" width="500px" :before-close="closeDialog"
      :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <div class="tips-box">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px"
          v-if="scoreOption[currentProvinceInfo.type]">
          <el-form-item :label="scoreOption[currentProvinceInfo.type].course1.name" prop="course1"
            v-if="scoreOption[currentProvinceInfo.type].course1">
            <el-checkbox-group v-model="form['course1']" :disabled="isDisabled_course1" :min="0"
              :max="scoreOption[currentProvinceInfo.type].course1.must">
              <el-checkbox v-for="tag in scoreOption[currentProvinceInfo.type].course1
        .tags" :label="tag" :key="tag">{{ tag }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item :label="scoreOption[currentProvinceInfo.type].course2.name" prop="course2"
            v-if="scoreOption[currentProvinceInfo.type].course2">
            <el-checkbox-group v-model="form['course2']" :disabled="isDisabled_course2" :min="0"
              :max="scoreOption[currentProvinceInfo.type].course2.must">
              <el-checkbox v-for="tag in scoreOption[currentProvinceInfo.type].course2
        .tags" :label="tag" :key="tag">{{ tag }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="成绩" :prop="scoreName == 'first' ? 'predict_score' : 'real_score'">
            <el-tabs v-model="scoreName" type="card">
              <el-tab-pane label="估分分数" name="first">
                <el-input v-model.number="form.predict_score" placeholder="100-750">
                  <template slot="append">分数</template>
                </el-input>
              </el-tab-pane>
              <el-tab-pane label="高考分数" name="second">
                <el-input v-model.number="form.real_score" placeholder="100-750">
                  <template slot="append">分数</template>
                </el-input>
                <el-input v-model.number="form.real_rank" style="margin-top: 10px">
                  <template slot="append">位次</template>
                </el-input>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">确定</el-button>
            <el-button v-if="score != ''" @click="closeDialog">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="vipDialogVisible" width="500px">
      <div class="f-col" style="align-items: center">
        <img style="width: 80px"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAABXCAYAAABxyNlsAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAxYSURBVHhe7Z1/iJTHGcfnmV1DNUJDvT8SSNXSowne2VpQsJDiCQYMNVCJtJFq7o5ESCH9Q9JAQitGRExpoAEFC224O5MSbSwGmtKEBKIgKCRQW8/Dtld6Wv8Qckporire7jx9vrPPbnbvnffdH7fv7qr7Ad2Z2bvbd78778zzPDPzLJkOgUeWfYkzX+7N510vEfdaa75unOk1RFlm7pHHxfqjAt8kQ1e0Mumc+ReTm8yymTTmfxdo+OJNfa6ttE1c/mhdlqeurXaGB0TIdczmESJTJmBjsDEivDnDhk9aZ04YM3OmXWK3XFw31r9aJBhkpidFzB5tTg350GbkdY6R4zEaPi9it46WiItemp+afk7e5NNE1K/NLUd69ZQMMa9nFvFr9IOJGW1OjdTFzY32b5MX2S3C9mpT2xGRr0iP3pdZtuTXtP5kTpubTmri8kjfgLP0K3mBVdrUcYjAk864lxYMTRzTpqbSdHF5ZMUqtna/FDcWWjofmfzOyOT3UrPH5KaJy79fsZhv2ANSHCq0NIafgOTNypVd8CaWNZNZZ2R8zE7pj3yBnX0w58xiIlsw3dg8LL+/uuGJks27xG4HDU8Uzbx50RRx3eEVvezoeKOTlUwyl+V338sbOpp1/z01H9MJk6e59OlaJvsEO7Op3rFer2WzHRz/RJsaZt7i+rGV6O16ewvGO/mdI2Tc+zQ4cUqbmw6GqTyRiExP1Dr+4+4RkXdkh88f0aaGmJe4udG+Z+QPHJILz2pTVWSmPusMvbBg8NyH2tQyCja2+aX8G/ANVZCxeE9m8PzLWq2bhsT13tV/pg8Ypme1qSq43Zjtrszyr7yZpvlTC7Mj/d+3lveLC/2wNiXA79BC3t6IXVy3uDzyrfuYcm+Lr79BmxKRT/8zGY9/kTGfv9YpPj/wjs3F6SG56/aKCPdrcxDcbda5x+qd6OoS1/fYi9N/rlVYYZSyt16gH/1jWusdh7dybtLP5C58UZuCyJ03bhfxd+rpwXWJ6w73HaplKJALybGhndmh8YPa1PHMjq7YYo0dkUk2PngEU23Zks21DmtWH6uCyas2Yc20I/vY7SQsgJdm2X0X8QdtikJmE1+6ultrVamp5xbMLfNBNasAtw5Z3myfmpjUptsOMd3uFw/zLSnGWhSOzXbpPG9qNZaq4hYcBHu6qh2LW2aR29qKaFPa+Lnl0tVDUnym0FKJ9O6b5Gi9HT53RpuCJIqLwd5dJxG2iuclwtqh8ce11nQKM/vVZ+UDflpuj6y8uaOZZT2vpG3SJc0xcg1XxIL4dpIFkTjmIlZQTVg/FEiP1WoqQFhL5oD0hFW4Hivmk9jZe/Xp1KCv9vxE3mDQ2ZFrKQ4fscSKC7dRHhKDMJi8MMamPRT4HjsHee2aHZhGwZ1BC2a3wlXXprkMwCHRcoR4cQthw1hgbjmirS2ZvJgjd494V/dpMVVgo5O1mxFv0KYKLPFeDFtarSAoLqwDeUiMx8KObVV8oJqVkjb2qb+NO+Lg0IdhKj91bZtWKwiKixUELcYxervZsfNlweD5dxHI0WoFMjTux9YArZaIiKtrXrGhOcQK4NJq9a7CuplXQuMvJrc8Lf6pVktUiIuxQ34w0QNBEKaTYwVpgsCTzDW7tFqBTLrPI6ilVU+FuLr8HRu5lz98GdEtrd6VIIAuOkRWKTDBciZf0TErxA2ZPOUgHttJYcN2YdkEh0V2Zlv52FsSF1H6JIcBMU0EurV6V+NXicUr1WoJ6Zw9Obp3k1bLey4PaiEIlmbavYLQSZD0Xtj6Wi2RMbakoxfXByqYnvQtATBDtmPNq5Oh4fELMvlH9jmINbWRf/cNH+QqiDt1LXGtX56b1yronYoz5qgWS8Dhyd9a4FdqvLjYxonHOLD8rcUuZdiMfU+LFdiMWecf/X+2UAkB8yvNfQW3M3b7ucsyZEa0kTbfWa3f0c3mEd8aQLp58NPpUkDG2MhdjSV7rGhYbJWXMTV2UQ5bjLTYJYC1HJyPcpZWW5xB0HoE6dEz2Lul1S4BEHKFNaXVEuRMr8XhDq1HwG7DrkdWHbnzIyYZdl1av/UyDjIXtNQlAcf8dy2WQb3WH0eKAftjtdglAXHAIsOCDBUibkKUHxuPtdglgUzGRnUik7Vix8Z6ZoUd3V2qQXmK6sSmBz034WBdYKt8lwg0/NeITjBvrQwObV38u5NBz40NI3LWdUOM88CKhLF2LOVst1c3CPaT2bLT312ayxUfFYvFzj6opS4JuDdWBnWCuLG2LA7QabFLApTjiE7EPGmTvDCcTNRiWxFbfFyLJRBU0mLbydlAfEYcMIsMG1qNkBh3aCVk/qClEp209IQImBZLoNPaQuqSGNjUcE4rfbCNSB5e9ceuCj32t7TQ7fRPdgA2Yx7SYgnEG8jvHr9hPyVjIhvJ5I1M22VLHuguqSeTH+v/y9z9deQyX7PYuCxPBPf2y63Xg0PKWu0SAJbCXGHFxp2CS+xNMbndTvrWADj9rcUuAVzObdFiieJ+hsLqr89iFAbH6rXYJYB4Yd/TYgnnyHdWdSJmzsSZNjI09Or5iC5zwM4aGQIiez5s1vjdSV5crJOJiLF5XpCvQItdysjP3rMxcKTgBPYzoKA9F7Mbj2kxgvyBto67uZGVQ260/48yK//bjfZ9kBvtfy7ukEcrscQRXWRIKOkoY+8X4OKlYblW57KmGalJ6sWN9b0hlxk60HGCli55tF1mIqwEdvxP0atkwmJotYvcA8WjY6WeC8TNfF2LIZBho6Wgx8YICwbyF6cTj/GnimPkaajwDeA1lp/JqxAXmeJw7FKrc0k80JYGoduuHHlzP9RiSwkdgET8Vi644rRPhbhQXbr2Pq1GQOqSVo51Yn8nWilJO+HThIkid7F80AeLE1mRCnEBUvCJwMF4AzaYIXWJVlNHLjhxU0rcdabJ7NjKDfKpVmRKQcxD3N1Ip4yIiwkCKfi0GkF6y17EI7SaKo7Nn7QYRMa4d7TYEnDXWsORXou7Xdzdz7RaIiIuQNYM+TTC8Qac1kZOmBaQWd6DU5pB71Gu7wItdMETjWmRn7qKVF+ROEKGZ4KnSYPiAuQ21GIUpheRE0ZrqeFPjYu5JULuKQbMdSh41S7kNWmfli/HjaxcS8RIp1gBO9oTt1lRPoh4YLjLTwS9M3mTM8gJQ8MTZ7XpjkVt2o9x12qTR3rtWbt0yZo4Wzu25wIkjcS2fa1WIOPdYmftceyg1qY7Ep8aK++OR4RF53Jma5ITkyzu8MQVmcBicw3ICy5HtoxOcEXTgm8Q0ikiTWEJ6XA5pAjAcSltCpIoLoDLK39sh1ZDDGiynTuO3Gjfz6ULRTxEZtqFFAFajSVxzC0nP9b3sti5CSfa+SAt7dnZLl+/2UBY5NLRajmj0uGGtZxIzeICN9Z3XH4l3gVm/hA5YW7nlAF+jJWhINhjfYbomfW1HmWoOiyUg2ycmCG1GkU8Fzd7z2l3+JttcUvnC6wCd50+CgorE7t1vLmeMyL1iYvFTEuPF23OEH7lwrnTs2N9t1WAHXasN7fmTF7AC8v0aKpZSIv4W+e6fSvOBi4C4x97Djr5RBAsHe95iYMgwkasnsJQgB5bfx7zhsQFuChNGikzajzwqOST3zXfFNVpgCAMYgUiQlz0bZTc5z9utHM0LG4Rn3CIzG/kD0U2lZQjAn+CDBut/gqXEIjH+rBhTB5gudYczK3s8Dh2+jTMvMUFfryyHPFigvivC4DIyQZ4Gvitno5hXsWGTeEwwUGoxY6tRlPEBXCDq6VGLYKeIS98AvkKcKx+bpC5mWD5G6u0WNVgQxuT7jAfK4BL26QPvmniFvHJ1on3yuRQszkmveWUTBzv45ByM9IXepMq57Zgw4YINhCaqMpB2BDRrWYnq2+6uKAwA1/bhkxx8gJ1BXYwAcoYfgJHPrFTEAfocM4rdBwJImLjMfbH+oPMGfOQ/M5aec2aNrHIB4pdk/sQj03DoklF3CLI5YBMcSLW88i7pc1tR3oqvpDuIJZmQisIzSJVcYv4rz/I5Hcj75YIXdc3oTQTTFby+kewSpvmOF+kJeIWQU9G3i2kh5JbMrQVKC1OYCdM5t78sVauXrRU3HL8LH5rwQYk25EeNYCVZX1q3mCCkjcGQU9iU1wremmItok7F0xOeedW+YnJn8WgXhG9V64wK2r1yO1cWnHGmCkP3h3FqRlj9RtUZQLMmszZ0OTXeoz5PyPIXeLcxhnsAAAAAElFTkSuQmCC"
          alt="" />
        <p class="m-t-30 fz-16 center" style="color: #333">开通VIP即可体验</p>
        <el-button style="" type="primary" class="m-t-30" @click="openVip">开通VIP</el-button>
      </div>
    </el-dialog>
    <el-dialog title="创建成绩" :visible.sync="dialogVisible" width="500px" :before-close="closeDialog"
      :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <div class="tips-box">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px"
          v-if="scoreOption[currentProvinceInfo.type]">
          <el-form-item :label="scoreOption[currentProvinceInfo.type].course1.name" prop="course1"
            v-if="scoreOption[currentProvinceInfo.type].course1">
            <el-checkbox-group v-model="form['course1']" :disabled="isDisabled_course1" :min="0"
              :max="scoreOption[currentProvinceInfo.type].course1.must">
              <el-checkbox v-for="tag in scoreOption[currentProvinceInfo.type].course1
        .tags" :label="tag" :key="tag">{{ tag }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item :label="scoreOption[currentProvinceInfo.type].course2.name" prop="course2"
            v-if="scoreOption[currentProvinceInfo.type].course2">
            <el-checkbox-group v-model="form['course2']" :disabled="isDisabled_course2" :min="0"
              :max="scoreOption[currentProvinceInfo.type].course2.must">
              <el-checkbox v-for="tag in scoreOption[currentProvinceInfo.type].course2
        .tags" :label="tag" :key="tag">{{ tag }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="成绩" :prop="scoreName == 'first' ? 'predict_score' : 'real_score'">
            <el-tabs v-model="scoreName" type="card">
              <el-tab-pane label="估分分数" name="first">
                <el-input v-model.number="form.predict_score" placeholder="100-750">
                  <template slot="append">分数</template>
                </el-input>
              </el-tab-pane>
              <el-tab-pane label="高考分数" name="second">
                <el-input v-model.number="form.real_score" placeholder="100-750">
                  <template slot="append">分数</template>
                </el-input>
                <el-input v-model.number="form.real_rank" style="margin-top: 10px">
                  <template slot="append">位次</template>
                </el-input>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">确定</el-button>
            <el-button v-if="score != ''" @click="closeDialog">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <card-bind :showModal="showModal" @closeModal="showModal = false" :routePath="''" :vipType="2"
      :reload="true"></card-bind>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getParams } from '@/utils';
import cardBind from '@/components/cardBind/index.vue';

export default {
  components: {
    cardBind,
  },
  data() {
    return {
      isFixed: false,
      isClickMore: false,
      vipDialogVisible: false,
      showModal: false,
      isShowMore: false,
      isShowHighFilter: false,
      dialogVisible: false,
      containerLoading: false,
      activeName: 'college',
      secondActiveName: '1',
      planConfig: {},
      filterOption: {},
      filterData: {
        provinces: [],
        features: [],
        categories: [],
        newCollege: [],
        keyword: '',
        sortKey: '',
        sortOrder: '',
        collegeList: [],
      },
      majorFilterOption: {
        features: [
          {
            name: '本科',
            value: '本科',
            isChecked: true,
          },
          {
            name: '专科',
            value: '专科',
            isChecked: false,
          },
        ],
        majorList: {
          name: '专业类别',
          type: 'majorList',
          list: [],
        },
        // newMajor: {
        //     name: '新增专业',
        //     type: 'newMajor',
        //     list: [{
        //         name:'非新增专业',
        //         value: '0',
        //         isChecked: false
        //     },{
        //         name:'新增专业',
        //         value: '1',
        //         isChecked: false
        //     }]
        // },
        majorType: {
          name: '高级筛选',
          list: [
            {
              name: '普通类',
              value: '普通类',
            },
            {
              name: '专项',
              value: '专项',
            },
            {
              name: '师范类',
              value: '师范类',
            },
            {
              name: '含学科评估',
              value: '含学科评估',
            },
            {
              name: '预科',
              value: '预科',
            },
            {
              name: '定向',
              value: '定向',
            },
            {
              name: '少数民族',
              value: '少数民族',
            },
            {
              name: '色盲色弱',
              value: '色盲色弱',
            },
            {
              name: '非新增专业',
              value: '0',
            },
            {
              name: '新增专业',
              value: '1',
            },
          ],
        },
        cost: {
          name: '学费级别',
          type: 'cost',
          list: [],
        },
      },
      majorFilterData: {
        features: [],
        majorList: [],
        majorType: [],
        newMajor: [],
        cost: [],
        keyword: '',
      },
      majorList: {
        name: '专业选择',
        type: 'majorList',
        list: [],
      },
      jobFilterOption: {
        jobList: {
          name: '职业选择',
          type: 'jobList',
          list: [],
        },
      },
      jobFilterData: {
        jobList: [],
        keyword: '',
        keywordInfo: {},
        sortKey: '',
        sortOrder: '',
      },
      arr_ben: [],
      arr_zhuan: [],
      loading: false,
      tableData: [], // 表格数据
      tableChildrenData: [], // 表格子数据
      sliderValue: [0, 0],
      total: {
        1: 0,
        2: 0,
      },
      page: 0,
      checkedColleges: [],
      majorTestList: [],
      chooseSubject: [],
      chooseSubjectData: [],
      userEvaluation: [],
      score: 0,
      course: '',
      scoreOption: {},
      scoreName: '',
      // rules  第一项判断scoreOption[currentProvinceInfo.type].course1是否存在，存在label为scoreOption[currentProvinceInfo.type].course1.name，check-box为scoreOption[currentProvinceInfo.type].course1.tags，必填项为scoreOption[currentProvinceInfo.type].course1.must，第二项判断scoreOption[currentProvinceInfo.type].course1是否存在，存在label为scoreOption[currentProvinceInfo.type].course1.name，第三项分数分为两个tab 1、估分分数 2、高考分数。 区间为100-750。必填一个
      rules: {
        course1: [{ required: true, message: '请选择' }],
        course2: [{ required: true, message: '请选择' }],
        real_score: [
          { required: true, message: '请输入高考分数', trigger: 'blur' },
          { type: 'number', message: '高考分数为数字', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value < 100 || value > 750) {
                callback(new Error('请输入100-750之间的数字'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        predict_score: [
          { required: true, message: '请输入估分分数', trigger: 'blur' },
          { type: 'number', message: '估分分数为数字', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value < 100 || value > 750) {
                callback(new Error('请输入100-750之间的数字'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
      form: {
        course1: [],
        course2: [],
        type: '1',
        real_score: '',
        real_rank: '',
        predict_score: '',
      },
      gridData: [],
      limit: {
        max: 1,
        now: 0,
      },
      vipList: {},
      isDisabled_course1: false,
      isDisabled_course2: false,
      scoreInfo: {},
      activeMajorKey: 0,
      activeJobKey: 0,
    };
  },
  // 计算属性
  computed: {
    container() {
      return container;
    },
    // 动态计算 filterData中的数据(除了keyword)合并成一个数组
    filterDataArr() {
      let arr = [];
      for (let key in this.filterData) {
        if (
          key === 'provinces' ||
          key === 'features' ||
          key === 'categories' ||
          key === 'newCollege' ||
          key === 'cost' ||
          key === 'collegeList'
        ) {
          arr = arr.concat(this.filterData[key]);
        }
      }
      for (let key in this.majorFilterData) {
        if (
          key === 'majorList' ||
          key === 'majorType' ||
          key === 'newMajor' ||
          key === 'cost'
        ) {
          arr = arr.concat(this.majorFilterData[key]);
        }
      }
      arr = arr.concat(
        this.userEvaluation.map((e) => {
          return { name: e, value: e, type: 'userEvaluation' };
        })
      );
      arr = arr.concat(
        this.chooseSubjectData.map((e) => {
          return { name: e, value: e, type: 'chooseSubject' };
        })
      );
      for (let key in this.jobFilterData) {
        if (key === 'jobList') {
          arr = arr.concat(this.jobFilterData[key]);
        }
      }
      return arr;
    },
    compareCollegeInfo() {
      //     遍历this.compareCollegeList；相同的collegeCode放到一个数组中
      let obj = {};
      console.log(this.compareCollegeList);
      this.compareCollegeList.forEach((item) => {
        if (!obj[item.collegeCode]) {
          obj[item.collegeCode] = [item];
        } else {
          obj[item.collegeCode].push(item);
        }
      });
      console.log(obj);
      return obj;
    },
    ...mapState({
      currentProvinceInfo: (state) => state.currentProvinceInfo,
    }),
    noMore() {
      return this.tableData.length >= this.total[this.secondActiveName];
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  watch: {
    // 监听majorFilterData.features的变化，如果有本科，就把本科的专业放到majorList中
    'majorFilterData.features': {
      handler(val) {
        if (val.includes('本科')) {
          this.majorList = {
            name: '专业选择',
            type: 'majorList',
            list: this.arr_ben,
          };
        } else {
          this.majorList = {
            name: '专业选择',
            type: 'majorList',
            list: this.arr_zhuan,
          };
        }
      },
      deep: true,
    },
  },
  async mounted() {
    const vipList = await this.$axios.get('/php/user.info');
    this.vipList = vipList.data.data.vipList;
    this.isShowMore = this.vipList[2];
    await this.getUserInfo();
    let scoreOption = await this.$axios.get('/php/score.config.get');
    this.scoreOption = scoreOption.data;
    this.scoreName = 'first';
    await this.getPlanConfig();
    await this.getFilterOption();
    await this.getGridData();

    await this.getMajorTestList();
    window.addEventListener('scroll', this.windowScroll);
    let list = this.$store.state.setFill;
    let list1 = this.$store.state.editFill;
    console.log(list1, '==list', list);
    if (list1 && list1.length > 0) {
      this.getFillData(list1);
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.windowScroll); //销毁滚动事件
  },
  methods: {
    //是否存在筛选条件
    getFillData(list) {
      for (let key of list) {
        console.log(this.filterOption, '===key', key);
        if (
          key.type === 'provinces' ||
          key.type === 'features' ||
          key.type === 'categories' ||
          key.type === 'newCollege' ||
          key.type === 'collegeList'
        ) {
          this.filterData[key.type].push(key);
          console.log(key, 'list===filterData', this.filterData);
          this.filterOption.map((e, i) => {
            switch (i) {
              case 0:
                e.type = 'provinces';
                break;
              case 1:
                e.type = 'categories';
                break;
              case 2:
                e.type = 'features';
                console.log(e.list);
                break;
            }

            e.list.map((a) => {
              if (a.name === key.name) {
                a.isChecked = true;
              }
              // return a;
            });
            // return e;
          });
        }
        if (
          key.type === 'majorList' ||
          key.type === 'majorType' ||
          key.type === 'newMajor' ||
          key.type === 'cost'
        ) {
          this.majorFilterData[key.type].push(key);
          console.log(this.majorFilterOption, '===list===major', key);
          this.majorFilterOption.majorType.list.map((a) => {
            if (a.name === key.name) {
              a.isChecked = true;
            }
          });
          this.majorFilterOption.cost.list.map((a) => {
            if (a.name === key.name) {
              a.isChecked = true;
            }
          });
        }
        if (key.type === 'jobList') {
          this.jobFilterData[key.type].push(key);
          console.log(this.jobFilterData, '===list===job', key);
        }
        if (key.type === 'chooseSubject') {
          this.chooseSubjectData.push(key.name);
          this.chooseSubject = this.chooseSubjectData;
        }
      }
    },
    async getGridData() {
      const list = await this.$axios.get('/php/pici.list');
      console.log(`list:${JSON.stringify(list)}`);
      this.gridData = list.data.data.list;
    },
    async getUserInfo() {
      const res = await this.$axios.get('/php/user.score.get');
      console.log(`res:${JSON.stringify(res)}`);
      const data = res.data;
      if (data.ret === 0) {
        // 字符串转为数组
        if (!_.isEmpty(data.data.score)) {
          this.scoreInfo = data.data.score;
          this.isDisabled_course1 = !_.isEmpty(data.data.score.course1);
          this.isDisabled_course2 = !_.isEmpty(data.data.score.course2);
          this.form['course1'] = _.isEmpty(data.data.score.course1)
            ? []
            : data.data.score.course1.split(',');
          this.form['course2'] = _.isEmpty(data.data.score.course2)
            ? []
            : data.data.score.course2.split(',');
          this.form['real_score'] =
            _.isNil(data.data.score.real_score) ||
              data.data.score.real_score === 0
              ? ''
              : data.data.score.real_score;
          this.form['predict_score'] =
            _.isNil(data.data.score.predict_score) ||
              data.data.score.predict_score === 0
              ? ''
              : data.data.score.predict_score;
          this.form['real_rank'] =
            _.isNil(data.data.score.real_rank) ||
              data.data.score.real_rank === 0
              ? ''
              : data.data.score.real_rank;
          this.score = data.data.score.score1;
          this.course = data.data.score.course;
        } else {
          this.dialogVisible = true;
          return false;
        }
        if (!_.isEmpty(data.data.limit)) {
          this.limit = data.data.limit;
        }
      }
    },
    async getMajorTestList() {
      const res = await this.$axios.get('/php/user.test.major.get');
      console.log(`res:${JSON.stringify(res)}`);
      this.majorTestList = res.data.data.map((e) => {
        return {
          label: e,
          value: e,
        };
      });
    },
    // 获取志愿配置信息
    async getPlanConfig() {
      const res = await this.$axios.get(
        '/php/plan.config.get?pcId=' + this.$route.query.id
      );
      this.planConfig = res && res.data.data;
      // this.planConfig.listType = [1,2]
      // this.planConfig.course = ['物理','生物','化学']
      if (this.planConfig.listType.length === 1) {
        this.secondActiveName = '2';
      }
      this.sliderValue = [
        this.planConfig.middleMinScore,
        this.planConfig.middleMaxScore,
      ];
      this.majorFilterOption.cost.list = this.planConfig.cost;
    },
    // 获取院校筛选配置
    async getFilterOption() {
      this.containerLoading = true;
      const res = await this.$axios.get('/php/college.list.config');
      res.data.data.map((e, i) => {
        switch (i) {
          case 0:
            e.type = 'provinces';
            break;
          case 1:
            e.type = 'categories';
            break;
          case 2:
            e.type = 'features';
            e.list = e.list.concat([
              { name: '新增院校', value: 1 },
              { name: '非新增院校', value: 0 },
            ]);
            console.log(e.list);
            break;
        }
        e.list.map((a) => {
          a.isChecked = false;
          return a;
        });
        return e;
      });
      this.filterOption = res.data.data;
      this.containerLoading = false;
    },
    // 获取专业筛选配置
    async getMajorFilterOption() {
      this.containerLoading = true;
      const res = await this.$axios.get('/php/major.list');
      this.arr_ben = res.data.data.ben.map((e) => {
        e.isChoose = false;
        e.show = false;
        e.major.map((a) => {
          a.show = false;
          a.checkAll = false;
          a.value = [];
          a.major.map((b) => {
            b.isChoose = false;
            return b;
          });
          return a;
        });
        return e;
      });
      this.arr_zhuan = res.data.data.zhuan.map((e) => {
        e.isChoose = false;
        e.show = false;
        e.major.map((a) => {
          a.show = false;
          a.checkAll = false;
          a.value = [];
          a.major.map((b) => {
            b.isChoose = false;
            return b;
          });
          return a;
        });
        return e;
      });
      this.majorFilterData.features = ['本科'];
      this.containerLoading = false;
    },
    // 获取职业筛选配置
    async getJobFilterOption() {
      this.containerLoading = true;
      const res = await this.$axios.get('/php/job.list');
      console.log(res.data.data);
      this.jobFilterOption.jobList.list = [];
      res.data.data.map((item) => {
        item.jobs = item.jobs.map((e) => {
          e.show = false;
          e.checkAll = false;
          e.value = [];
          return e;
        });
        this.jobFilterOption.jobList.list = this.jobFilterOption.jobList.list.concat(
          item.jobs
        );
      });
      this.containerLoading = false;
    },
    async submit() {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      this.loading = true;
      const res = await this.$axios.post('/php/plan.oneKey', {
        province: this.filterData.provinces.map((e) => e.name),
        categories: this.filterData.categories.map((e) => e.value),
        features: this.filterData.features.map((e) => e.value),
        collegeList: this.filterData.collegeList.map((e) => e.name),
        newCollege: this.filterData.newCollege.map((e) => e.value),
        majorList:
          this.majorFilterData.keyword.length > 0
            ? this.majorFilterData.majorList
              .map((e) => e.name)
              .concat([this.majorFilterData.keyword])
              .concat(this.userEvaluation.map((e) => e))
            : this.majorFilterData.majorList
              .map((e) => e.name)
              .concat(this.userEvaluation.map((e) => e)),
        majorType: this.majorFilterData.majorType.map((e) => e.name),
        newMajor: this.majorFilterData.newMajor.map((e) => e.value),
        cost: this.majorFilterData.cost.map((e) => e.value),
        jobList: this.jobFilterData.jobList.map((e) => e.id),
        chooseSubject: this.chooseSubjectData,
        pcId: this.$route.query.id,
        minScore: this.sliderValue[0],
        maxScore: this.sliderValue[1],
      });
      if (res.data.ret == 0) {
        this.$message({
          message: '填报成功',
          type: 'success',
        });
        //     跳转到志愿表详情
        this.$router.push(
          '/tzy/details?id=' + encodeURIComponent(res.data.data)
        );
      }
      this.loading = false;
      // this.collegeList = res.data.data
    },

    // 专业选择
    changeMajorType(name) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      this.majorFilterData.features = [name];
      this.majorFilterOption.features = this.majorFilterOption.features.map(
        (e) => {
          e.isChecked = e.name === name;
          return e;
        }
      );
      this.filterData.features = [];
      this.filterOption[2].list = this.filterOption[2].list.map((e) => {
        e.isChecked = false;
        return e;
      });
    },
    openMajorFilter(tag) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      console.log(`tag:${JSON.stringify(tag)}`);
      if (tag.level == 1) {
        this.majorList.list = this.majorList.list.map((e) => {
          if (e.id == tag.id) {
            e.isChoose = (!tag.show && tag.isChoose) || !tag.show;
          } else {
            e.isChoose = false;
            e.show = false;
            e.major.map((a) => {
              a.show = false;
              return a;
            });
          }
          return e;
        });
        tag.value = tag.major.filter((e) => e.isChoose).map((e) => e.id);
      } else if (tag.level == 2) {
        this.majorList.list = this.majorList.list.map((e) => {
          if (e.id == tag.parentCode) {
            e.major = e.major.map((a) => {
              if (a.id != tag.id) {
                a.show = false;
              }
              return a;
            });
          }
          return e;
        });
        tag.value = tag.major.filter((e) => e.isChoose).map((e) => e.name);
      }
      console.log(`tag.value:${JSON.stringify(tag.value)}`);
      tag.show = !tag.show;
      // if(tag.eduLevel === 'ben'){
      //     // 遍历数组，将当前点击的项的isChecked属性取反
      //     this.arr_ben = this.arr_ben.map(e=>{
      //         if(e.id == tag.id){
      //             e.isChoose?e.isChoose = false : e.isChoose = true
      //         }
      //         return e
      //     })
      //     // this.arr_ben = this.arr_ben.map(e=>{
      //     //     if(e.id === tag.id){
      //     //         e.isChecked = true
      //     //         console.log(e.isChecked)
      //     //     }
      //     //     return e
      //     // })
      // }else if(tag.eduLevel == 'zhuan'){
      //     this.arr_zhuan = this.arr_zhuan.map(e=>{
      //         if(e.id == tag.id){
      //             e.isChoose?e.isChoose = false : e.isChoose = tru
      //         }
      //         return e
      //     })
      // }
    },
    openJobFilter(tag) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      this.jobFilterOption.jobList.list = this.jobFilterOption.jobList.list.map(
        (e) => {
          if (e.id == tag.id) {
            e.isChoose = (!tag.show && tag.isChoose) || !tag.show;
          } else {
            e.isChoose = false;
            e.show = false;
          }
          return e;
        }
      );
      tag.value = tag.jobs.filter((e) => e.isChoose).map((e) => e.id);
      tag.show = !tag.show;
    },
    setHighFilter() {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      this.chooseSubjectData = this.chooseSubject;
      this.isShowHighFilter = false;
      // e为true时，添加到数组中，为false时，从数组中删除

      // if(e){
      //     this.majorFilterData.features.push(name)
      // }else{
      //     this.majorFilterData.features.splice(this.majorFilterData.features.indexOf(name),1)
      // }
    },
    clearMajorFilter(tag, parent) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      tag.value = [];

      const res = tag.major.filter((e) => e.isChoose);
      // lodash的pullAll方法，删除this.majorFilterData.majorList数组中与res数组中相同的元素
      // let t = _.cloneDeep(this.majorFilterData.majorList)
      // // lodash根据数组中ID删除元素
      //
      // t = _.remove(t,res)
      // this.majorFilterData.majorList = []
      // this.majorFilterData.majorList = t
      // this.majorFilterData.majorList = _.remove(this.majorFilterData.majorList, res)
      // tag = tag.major.map(e => {
      //     e.isChoose = false
      //     return e
      // })
      // tag.isChoose = false
      // parent.isChoose = false
      // console.log(`parent:${JSON.stringify(parent)}`)
      // if (parent.eduLevel === 'ben') {
      //     this.arr_ben = this.arr_ben.map(e => {
      //         console.log(`e:${JSON.stringify(e)}`)
      //         // if(e.id == tag.id){
      //         //     alert(e.id)
      //         e.major.map(a => {
      //             a.isChoose = false
      //             return a
      //         })
      //         // }
      //         e.isChoose = false
      //         return e
      //     })
      // } else if (parent.eduLevel == 'zhuan') {
      //     this.arr_zhuan = this.arr_zhuan.map(e => {
      //         if (e.id == tag.id) {
      //             e.major.map(a => {
      //                 a.isChoose = false
      //                 return a
      //             })
      //         }
      //         return e
      //     })
      // }
      // this.majorFilterDataArr = _.pullAll(this.majorFilterDataArr,res)
    },
    clearJobFilter(tag) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      // // 根据tag.value数组中的id，获取tab.jobs中的数据
      // const res = tag.value.map(e => this.jobFilterData.jobList.find(a => a.id === e))
      // this.jobFilterData.jobList =  _.without(this.jobFilterData.jobList, ...res)
      // console.log(`this.jobFilterData.jobList:${JSON.stringify(this.jobFilterData.jobList)}`)
      // 删除this.jobFilterData.jobList数组中与tag.value中ID相同的元素
      // this.jobFilterData.jobList = _.remove(this.jobFilterData.jobList, res)
      // console.log(`data:${JSON.stringify(data)}`)
      tag.value = [];
      tag.checkAll = false;
      // this.jobFilterData.jobList = []
      // this.jobFilterData.jobList = data
    },
    setMajorFilter(tag, parent) {
      const res = this.majorFilterData.majorList.filter(
        (e) => e.name == tag.name
      );
      console.log('===setMajorFilter', res);
      if (res && res.length > 0) {
        const data = this.majorFilterData.majorList.filter(
          (e) => e.name != tag.name
        );
        this.majorFilterData.majorList = data;
        console.log(
          this.majorFilterData.majorList,
          '===setMajorFilter>0',
          data
        );
      } else {
        tag.type = 'majorList';
        this.majorFilterData.majorList.push(tag);
      }
      // if (!this.isShowMore) {
      //   this.showMore();
      //   return false;
      // }
      // tag.show = false;
      // parent.show = false;
      // tag.major.map((e) => {
      //   if (e.isChoose) {
      //     e.show = true;
      //   }
      //   return e;
      // });
      // // 上一次选中的数据
      // const isChooseArr = tag.major.filter((e) => e.isChoose);
      // // 当前选中的数据
      // let res = tag.value.map((e) => tag.major.find((a) => a.name === e));
      // // 取出 isChooseArr 中存在，res中不存在的元素
      // let diff = _.differenceBy(isChooseArr, res, 'name');
      // console.log(`isChooseArr:${JSON.stringify(isChooseArr)}`);
      // console.log(`res:${JSON.stringify(res)}`);
      // console.log(`diff:${JSON.stringify(diff)}`);
      // // 将diff中的元素从this.jobFilterData.jobList中删除
      // this.majorFilterData.majorList = _.differenceBy(
      //   this.majorFilterData.majorList,
      //   diff,
      //   'name'
      // );
      // // 将diff中的元素isChoose设置为false
      // diff = diff.map((e) => {
      //   e.isChoose = false;
      //   return e;
      // });
      // // 将res中的元素isChoose设置为true
      // res = res.map((e) => {
      //   e.isChoose = true;
      //   return e;
      // });
      // tag.isChoose = tag.major.filter((e) => e.isChoose).length > 0;
      // console.log(`res:${JSON.stringify(res)}`);
      // // const res = tag.major.filter(e => e.isChoose)
      // //   判断res数组中对象元素是否已经存在，存在则不添加，不存在的添加
      // res.map((e) => {
      //   if (!this.majorFilterData.majorList.some((a) => a.name === e.name)) {
      //     this.majorFilterData.majorList.push({
      //       ...e,
      //       type: 'majorList',
      //     });
      //   }
      // });
      // this.majorFilterData.majorList = this.majorFilterData.majorList.concat(res)
    },
    setJobFilter(tag) {
      const res = this.jobFilterData.jobList.filter((e) => e.name == tag.name);
      if (res && res.length > 0) {
        const data = this.jobFilterData.jobList.filter(
          (e) => e.name != tag.name
        );
        this.jobFilterData.jobList = data;
        console.log(this.jobFilterData.jobList, '===setMajorFilter>0', data);
      } else {
        tag.type = 'jobList';
        this.jobFilterData.jobList.push(tag);
      }
      // if (!this.isShowMore) {
      //   this.showMore();
      //   return false;
      // }
      // tag.show = false;
      // // 上一次选中的数据
      // const isChooseArr = tag.jobs.filter((e) => e.isChoose);
      // // 当前选中的数据
      // let res = tag.value.map((e) => tag.jobs.find((a) => a.id === e));
      // // 取出 isChooseArr 中存在，res中不存在的元素
      // let diff = _.differenceBy(isChooseArr, res, 'id');
      // console.log(`isChooseArr:${JSON.stringify(isChooseArr)}`);
      // console.log(`res:${JSON.stringify(res)}`);
      // console.log(`diff:${JSON.stringify(diff)}`);
      // // 将diff中的元素从this.jobFilterData.jobList中删除
      // this.jobFilterData.jobList = _.differenceBy(
      //   this.jobFilterData.jobList,
      //   diff,
      //   'id'
      // );
      // // 将diff中的元素isChoose设置为false
      // diff = diff.map((e) => {
      //   e.isChoose = false;
      //   return e;
      // });
      // // 将res中的元素isChoose设置为true
      // res = res.map((e) => {
      //   e.isChoose = true;
      //   return e;
      // });
      // console.log(`res:${JSON.stringify(res)}`);

      // res.map((e) => {
      //   if (!this.jobFilterData.jobList.some((a) => a.id === e.id)) {
      //     this.jobFilterData.jobList.push({
      //       ...e,
      //       type: 'jobList',
      //     });
      //   }
      // });
    },
    majorFilterClick(secondIndex, specialType) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      let type = specialType;
      if (secondIndex === -1) {
        // 选择不限清除所有筛选条件
        this.majorFilterData[type] = [];
        if (type === 'majorList') {
          if (this.majorFilterData.features[0] == '本科') {
            this.arr_ben = this.arr_ben.map((e) => {
              e.isChoose = false;
              e.major.map((a) => {
                a.isChoose = false;
                return a;
              });
              return e;
            });
          } else {
            this.arr_zhuan = this.arr_zhuan.map((e) => {
              e.isChoose = false;
              e.major.map((a) => {
                a.isChoose = false;
                return a;
              });
              return e;
            });
          }
        } else {
          this.majorFilterOption[type].list = this.majorFilterOption[
            type
          ].list.map((e) => {
            e.isChecked = false;
            return e;
          });
        }
        return false;
      }
      const data = this.majorFilterOption['majorType'].list[secondIndex];
      console.log(data);
      if (data.isChecked) {
        // 已选择需在filterData中删除
        this.majorFilterData[type] = _.without(
          this.majorFilterData[type],
          data
        );
      } else {
        // 未选择在filterData中插入
        data.type = type;
        this.majorFilterData[type].push(data);
      }
      data.isChecked = !data.isChecked;
    },
    jobFilterClick(secondIndex, specialType) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      let type = specialType;
      if (secondIndex === -1) {
        // 选择不限清除所有筛选条件
        this.jobFilterData[type] = [];
        this.jobFilterOption[type].list = this.jobFilterOption[type].list.map(
          (e) => {
            e.isChecked = false;
            return e;
          }
        );
        return false;
      }
      const data = this.jobFilterOption[type].list[secondIndex];
      console.log(data);
      if (data.isChecked) {
        // 已选择需在filterData中删除
        this.jobFilterData[type] = _.without(this.jobFilterData[type], data);
      } else {
        // 未选择在filterData中插入
        data.type = type;
        this.jobFilterData[type].push(data);
      }
      data.isChecked = !data.isChecked;
    },
    costFilterClick(secondIndex) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      let type = 'cost';
      if (secondIndex === -1) {
        // 选择不限清除所有筛选条件
        this.majorFilterData[type] = [];
        this.majorFilterOption[type].list = this.majorFilterOption[
          type
        ].list.map((e) => {
          e.isChecked = false;
          return e;
        });
        return false;
      }
      const data = this.majorFilterOption[type].list[secondIndex];
      console.log(data);
      if (data.isChecked) {
        // 已选择需在filterData中删除
        this.majorFilterData[type] = _.without(
          this.majorFilterData[type],
          data
        );
      } else {
        // 未选择在filterData中插入
        data.type = type;
        this.majorFilterData[type].push(data);
      }
      data.isChecked = !data.isChecked;
    },
    filterClick(firstIndex, secondIndex, specialType) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      let type = '';
      switch (firstIndex) {
        case 0:
          type = 'provinces';
          break;
        case 1:
          type = 'categories';
          break;
        case 2:
          specialType && specialType == 'newCollege'
            ? (type = 'newCollege')
            : (type = 'features');
          break;
      }
      if (secondIndex === -1) {
        // 选择不限清除所有筛选条件
        this.filterData[type] = [];
        this.filterOption[firstIndex].list = this.filterOption[
          firstIndex
        ].list.map((e) => {
          e.isChecked = false;
          return e;
        });
        return false;
      }
      const data = this.filterOption[firstIndex].list[secondIndex];
      if (data.isChecked) {
        // 已选择需在filterData中删除
        this.filterData[type] = _.without(this.filterData[type], data);
      } else {
        // 未选择在filterData中插入
        data.type = type;
        this.filterData[type].push(data);
      }
      data.isChecked = !data.isChecked;
    },
    jobFilter(val, tag) {
      console.log(`tag:${JSON.stringify(tag)}`);
      console.log(`val:${JSON.stringify(val)}`);
      if (val) {
        console.log(`val:${JSON.stringify(val)}`);
        tag.checkAll = tag.value.length === tag.jobs.length;
      } else {
        tag.checkAll = false;
      }
    },
    majorFilter(val, tag) {
      if (val) {
        console.log(`val:${JSON.stringify(val)}`);
        tag.checkAll = tag.value.length === tag.major.length;
      } else {
        tag.checkAll = false;
      }
    },
    handleCheckAllChange(val, tag) {
      if (val) {
        if (this.activeName === 'job') {
          tag.value = tag.jobs.map((e) => e.id);
          tag = tag.jobs.map((e) => {
            e.isChoose = true;
            return e;
          });
        } else {
          tag.value = tag.major.map((e) => e.name);
        }
        tag.checkAll = true;
      } else {
        tag.value = [];
        tag.checkAll = false;
      }
    },
    // 搜索大学（大于两个字符搜索）
    async search(queryString, cb) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      let list = [];
      if (queryString.length > 1) {
        let requestParams = {
          keywords: queryString,
          pcId: this.$route.query.id,
          type: this.activeName,
        };
        const res = await this.$axios.get(
          '/php/plan.keywords.get?' + getParams(requestParams)
        );
        list = res && res.data.data;

        if (
          this.activeName == 'college' ||
          this.activeName == 'job' ||
          this.activeName == 'major'
        ) {
          res.data.data.unshift({
            value: `在推荐结果中搜索“${queryString}”`,
            name: queryString,
          });
        }
        res.data.data = res.data.data.map((e) => {
          if (this.activeName == 'college') {
            e.type = 'collegeList';
          } else if (this.activeName == 'major') {
            e.type = 'majorList';
          } else if (this.activeName == 'job') {
            e.type = 'jobList';
          }
          return e;
        });
        console.log(`res.data.data:${JSON.stringify(res.data.data)}`);
        cb(res.data.data);
      } else {
        cb([]);
      }
    },
    highLightText(text, keyword) {
      if (keyword) {
        return text.replace(
          new RegExp(keyword, 'g'),
          '<span style="color:#910000">' + keyword + '</span>'
        );
      } else {
        return text;
      }
    },
    // 选择搜索结果
    handleSelect(item) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      if (item.value.indexOf('在推荐结果中搜索') > -1) {
        let str = item.value.replace('在推荐结果中搜索“', '');
        item.value = str.substring(0, str.length - 1);
      }
      switch (this.activeName) {
        case 'college':
          this.filterData.keyword = '';
          // 判断this.filterData.collegeList 是否包含item.name
          if (!this.filterData.collegeList.some((e) => e.name === item.name)) {
            console.log(`item:${JSON.stringify(item)}`);
            let college = {
              name: _.has(item, item.name) ? item.name : item.value,
              value: item.value,
              type: _.has(item, item.type) ? item.type : 'collegeList',
            };
            this.filterData.collegeList.push(college);
          }
          break;
        case 'major':
          this.majorFilterData.keyword = '';
          if (
            !this.majorFilterData.majorList.some((e) => e.name === item.name)
          ) {
            let major = {
              name: _.has(item, item.name) ? item.name : item.value,
              value: item.value,
              type: _.has(item, item.type) ? item.type : 'majorList',
            };
            this.majorFilterData.majorList.push(major);
          }
          break;
        case 'job':
          this.jobFilterData.keyword = '';
          if (!this.jobFilterData.jobList.some((e) => e.name === item.name)) {
            this.jobFilterData.jobList.push({
              name: item.name,
              id: item.value,
            });
          }
          break;
      }
    },
    async clearJobFilterData() {
      this.containerLoading = true;
      this.tableData = [];
      await this.getPlanConfig();
      await this.getFilterOption();
      await this.getJobFilterOption();
      await this.getMajorFilterOption();
      await this.getMajorTestList();
      this.jobFilterData = {
        jobList: [],
        keyword: '',
        keywordInfo: {},
        sortKey: '',
        sortOrder: '',
      };
      this.filterData = {
        provinces: [],
        features: [],
        categories: [],
        newCollege: [],
        keyword: '',
        sortKey: '',
        sortOrder: '',
        collegeList: [],
      };
      this.majorFilterData = {
        features: ['本科'],
        majorList: [],
        majorType: [],
        newMajor: [],
        cost: [],
        keyword: '',
      };
      this.majorFilterOption.majorType.list = this.majorFilterOption.majorType.list.map(
        (e) => {
          e.isChecked = false;
          return e;
        }
      );
      this.userEvaluation = [];
      this.chooseSubjectData = [];
      this.chooseSubject = [];
      this.containerLoading = false;
    },
    handleSelectMajor(data) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      console.log(data);
    },
    // 滑块改变
    handleSliderChange(val) {
      console.log(`this.sliderValue:${JSON.stringify(this.sliderValue)}`);
    },
    // 删除filerData中的某一项
    removeMajorFilterDataItem(item) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      console.log(item);
      let type = item.type ? item.type : 'majorList';
      this.majorFilterData[type] = _.without(this.majorFilterData[type], item);
      // forEach遍历majorFilterOption对象，将isChecked置为false
      if (type == 'majorList') {
        if (this.majorFilterData.features.includes('本科')) {
          this.majorList.list = this.majorList.list.map((e) => {
            e.major = e.major.map((a) => {
              a.major = a.major.map((b) => {
                if (b.id == item.id) {
                  b.isChoose = false;
                }
                return b;
              });
              a.checkAll = a.major.every((e) => e.isChoose);
              a.value = a.major.filter((e) => e.isChoose).map((e) => e.name);
              a.isChoose = a.major.some((e) => e.isChoose);
              return a;
            });
            return e;
          });
        } else {
          this.arr_zhuan = this.arr_zhuan.map((e) => {
            e.major = e.major.map((a) => {
              if (a.id == item.id) {
                a.isChoose = false;
              }
              return a;
            });
            e.major.filter((a) => a.isChoose).length > 0
              ? (e.isChoose = true)
              : (e.isChoose = false);
            return e;
          });
        }
      } else if (type == 'userEvaluation') {
        this.userEvaluation = this.userEvaluation.filter(
          (e) => e !== item.value
        );
      } else {
        type == 'newMajor' ? (type = 'majorType') : '';
        this.majorFilterOption[type].list.forEach((e) => {
          console.log(e.value, item.value);
          if (e.value === item.value) {
            e.isChecked = false;
          }
        });
      }
    },
    removeJobFilterDataItem(item) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      console.log(item);
      this.jobFilterData.jobList = _.without(this.jobFilterData.jobList, item);
      // forEach遍历majorFilterOption对象，将isChecked置为false
      this.jobFilterOption.jobList.list.forEach((e) => {
        e.jobs = e.jobs.map((a) => {
          if (a.id == item.id) {
            a.isChoose = false;
          }
          return a;
        });
        e.jobs.filter((a) => a.isChoose).length > 0
          ? (e.isChoose = true)
          : (e.isChoose = false);
        return e;
      });
    },
    // 删除filerData中的某一项
    removeFilterDataItem(item) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      this.filterData[item.type] = _.without(this.filterData[item.type], item);
      this.filterOption.map((e) => {
        if (e.type === item.type) {
          e.list.map((a) => {
            if (a.value === item.value) {
              a.isChecked = false;
            }
            return a;
          });
        }
        return e;
      });
    },
    // table排序
    handleSortChange({ column, prop, order }) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      console.log(column, prop, order);
      this.filterData.sortKey = prop;
      this.filterData.sortOrder = order == 'ascending' ? 'asc' : 'desc';
    },
    // 查看院校详情
    viewCollegeDetail(data) {
      const param = {
        id: data.collegeCode,
        name: data.collegeName,
      };
      window.open('/college/detail?' + getParams(param));
    },
    handleClick(tab, event) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      this.containerLoading = true;
      switch (this.activeName) {
        case 'college':
          if (_.isEmpty(this.filterOption)) {
            this.getFilterOption();
          }
          this.majorList.list = this.majorList.list.map((e) => {
            e.show = false;
            e.major = e.major.map((a) => {
              a.show = false;
              return a;
            });
            return e;
          });
          this.jobFilterOption.jobList.list = this.jobFilterOption.jobList.list.map(
            (e) => {
              e.show = false;
              return e;
            }
          );
          break;
        case 'major':
          if (_.isEmpty(this.arr_ben) && _.isEmpty(this.arr_zhuan)) {
            this.getMajorFilterOption();
          }
          this.jobFilterOption.jobList.list = this.jobFilterOption.jobList.list.map(
            (e) => {
              e.show = false;
              return e;
            }
          );
          break;
        case 'job':
          if (_.isEmpty(this.jobFilterOption.jobList.list)) {
            this.getJobFilterOption();
          }
          this.majorList.list = this.majorList.list.map((e) => {
            e.show = false;
            e.major = e.major.map((a) => {
              a.show = false;
              return a;
            });
            return e;
          });
          this.jobFilterOption.jobList.list = this.jobFilterOption.jobList.list.map(
            (e) => {
              e.show = false;
              return e;
            }
          );
          break;
      }
      this.containerLoading = false;
    },
    // 展开子节点
    async handleExpand(scope) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      // 关闭所有展开的子节点
      this.tableData.map((e, i) => {
        if (i !== scope.$index) {
          e.isOpen = false;
          this.$refs.table.toggleRowExpansion(this.tableData[i], false);
        }
        return e;
      });
      this.tableData[scope.$index].isOpen = !this.tableData[scope.$index]
        .isOpen;
      this.$refs.table.toggleRowExpansion(
        this.tableData[scope.$index],
        this.tableData[scope.$index].isOpen
      );
      const res = await this.$axios.get(
        '/php/plan.list.collegeMajor.get?' +
        getParams({
          pcId: this.$route.query.id,
          collegeEnrollCode: scope.row.collegeEnrollCode,
        })
      );
      this.tableChildrenData = res.data.data.list;
      console.log(scope);
      console.log('展开');
    },
    // 删除对比
    removeCompare(data, type) {
      if (type === 'all') {
        this.compareCollegeList = this.compareCollegeList.filter(
          (e) => e.collegeCode != data
        );
      } else {
        this.compareCollegeList = _.without(this.compareCollegeList, data);
        this.checkedColleges = _.without(this.checkedColleges, data);
      }
    },
    // 添加对比
    addCompareList(data) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      this.compareCollegeList.push(data);
    },
    removeCompareList(data) {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      this.compareCollegeList = _.without(this.compareCollegeList, data);
    },
    isChecked(id) {
      const arr = this.compareCollegeList.filter((e) => e.id === id);
      return arr.length > 0;
    },
    //     保存志愿表
    async savePlan() {
      if (!this.isShowMore) {
        this.showMore();
        return false;
      }
      if (this.limit.now >= this.limit.max) {
        this.$message({
          message: '您的今日可修改次数已达上限',
          type: 'warning',
        });
        return false;
      }
      // 最少选择3个院校
      if (this.compareCollegeList.length < 3) {
        this.$message({
          message: '最少选择3个院校',
          type: 'warning',
        });
        return false;
      }

      const res = await this.$axios.post('/php/user.plan.save', {
        pcId: this.$route.query.id,
        plan: this.compareCollegeList.map((e) => e.id),
      });
      console.log(res);
      if (res.data.ret == 0) {
        this.$message({
          message: '保存成功',
          type: 'success',
        });
        //     跳转到志愿表详情
        this.$router.push(
          '/tzy/details?id=' + encodeURIComponent(res.data.data.id)
        );
      }
    },
    openDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    submitForm(formName) {
      if (!_.isEmpty(this.scoreInfo)) {
        if (
          this.form.predict_score == this.scoreInfo.predict_score &&
          this.form.real_rank == this.scoreInfo.real_rank &&
          this.form.real_score == this.scoreInfo.real_score
        ) {
          this.$message({
            message: '您的成绩未发生变化',
            type: 'warning',
          });
          return false;
        }
      }
      if (!_.isEmpty(this.limit) && this.limit.now >= this.limit.max) {
        this.$message({
          message: '您的今日可修改次数已达上限',
          type: 'warning',
        });
        return false;
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          console.log(_.pickBy(this.form, _.identity));
          const message = _.isEmpty(this.scoreInfo)
            ? `确认提交吗，选科只能选择1次，请认真核对。`
            : `确认提交吗，您今日修改次数还剩${this.limit.max -
            this.limit.now}次`;
          // 二次确认
          this.$confirm(message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              console.log(_.pickBy(this.form, _.identity));
              // lodash _.pickBy(this.form, _.identity)  去除对象中值为空的属性返回新对象
              let data = _.pickBy(this.form, _.identity);
              // 判断this.scoreOption[this.currentProvinceInfo.type].course1 是否存在 并且 ...must == 1 true则data.course1 = data.course1[0] false则data.course1 = data.course1
              if (
                this.scoreOption[this.currentProvinceInfo.type].course1 &&
                this.scoreOption[this.currentProvinceInfo.type].course1.must ==
                1
              ) {
                data.course1 = data.course1[0];
              } else {
                data.course1 = data.course1;
              }
              if (
                this.scoreOption[this.currentProvinceInfo.type].course2 &&
                this.scoreOption[this.currentProvinceInfo.type].course2.must ==
                1
              ) {
                data.course2 = data.course2[0];
              } else {
                data.course2 = data.course2;
              }
              // 去除data对象中值为空的数组
              for (let key in data) {
                if (data[key].length == 0) {
                  delete data[key];
                }
              }

              const res = await this.$axios.post('/php/user.score.set', data);
              if (res.data.ret === 0) {
                this.$message({
                  message: '创建成功',
                  type: 'success',
                });
                this.dialogVisible = false;
                await this.getUserInfo();
                this.scoreName = 'first';
                this.activeName = 'college';
                await this.clearJobFilterData();
                //   清除表单
                this.$refs[formName].resetFields();
              }
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交',
              });
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async nav(data) {
      // this.$router.replace({
      //     path: '/tzy/intelligent-recommendation',
      //     query: {id: data.id, batchName: data.bzType}
      // })
      this.$router.push({ query: { id: data.id, batchName: data.bzType } });

      this.scoreName = 'first';
      this.activeName = 'college';
      await this.clearJobFilterData();
      // window.location.reload();
    },
    //获取当前可视范围的高度
    getClientHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      } else {
        clientHeight = Math.max(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      }
      return clientHeight;
    },

    //获取文档完整的高度
    getScrollHeight() {
      return Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      );
    },

    //获取当前滚动条的位置
    getScrollTop() {
      var scrollTop = 0;
      //window.pageYOffset = document.documentElement.scrollTop
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      return scrollTop;
    },
    // 防抖函数
    debounce(fn, delay) {
      let timer = null;
      return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          console.log('防抖');
          fn.apply(context, args);
        }, delay);
      };
    },
    //回调函数
    async windowScroll() {
      //获取三个值
      // var scrollTop = this.getScrollTop()
      // var clientHeight = this.getClientHeight()
      // var scrollHeight = this.getScrollHeight()
      // let top1 = this.$refs.middle.offsetTop
      // scrollTop > (top1 + 133) ? this.isFixed = true : this.isFixed = false
      // //如果满足公式则，确实到底了
      // // console.log(scrollTop + clientHeight, scrollHeight)
      // // 绝对值函数
      // console.log(parseInt(String(scrollTop + clientHeight)) - scrollHeight)
      // if (parseInt(String(scrollTop + clientHeight)) - scrollHeight === -1 || parseInt(String(scrollTop + clientHeight)) - scrollHeight === 0) {
      //     //发送异步请求请求数据，同时携带offset并自增offset
      //     //noMore是自定义变量，如果是最后一批数据则以后都不加载
      //     console.log('滚动到底部')
      //     console.log(`this.isShowMore:${JSON.stringify(this.isShowMore)}`)
      //     if (!this.noMore && this.isShowMore) {
      //         this.debounce(this.getTableData('loadMore', scrollHeight - 1000), 3000)
      //     }
      // }
    },
    headerFixed() {
      // 获取$refs.table距离文档顶部的高度
      if (this.isFixed) {
        return 'fixed-title';
      } else {
        return 'nofixed-title';
      }
    },
    async showMore() {
      this.vipDialogVisible = true;
      // await this.getGridData()
    },
    openVip() {
      this.vipDialogVisible = false;
      this.showModal = true;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    removeItem(item) {
      const list = [
        'provinces',
        'features',
        'categories',
        'newCollege',
        'collegeList',
      ];
      const list1 = [
        'cost',
        'newMajor',
        'majorList',
        'majorType',
        'userEvaluation',
      ];
      const list2 = ['jobList'];
      const list3 = ['chooseSubject'];
      if (list.includes(item.type)) {
        this.removeFilterDataItem(item);
      } else if (list1.includes(item.type)) {
        this.removeMajorFilterDataItem(item);
      } else if (list2.includes(item.type)) {
        this.removeJobFilterDataItem(item);
      } else if (list3.includes(item.type)) {
        this.chooseSubjectData = this.chooseSubjectData.filter(
          (e) => e !== item.name
        );
        this.chooseSubject = this.chooseSubjectData;
      }
    },
    //返回
    goBack() {
      this.$router.go(-1);
    },
    clickFillBtn(i) {
      console.log(this.$refs[`item_${i}`], '===clickFillBtn', this.$refs);
      this.$refs[`item_${i}`][0].toggle();
    },
    clickFillBtn1(i) {
      console.log(this.$refs[`item_${i}`], '===clickFillBtn', this.$refs);
      this.$refs[`item_${i}`].toggle();
    },
    handleMajor(e) {
      console.log('handleMajor', e);
    },
    handleJob(e) {
      console.log('handleJob', e);
    },
    setFillData() {
      this.$store.commit('editFill', this.filterDataArr);
      let planList = {
        province: this.filterData.provinces.map((e) => e.name),
        categories: this.filterData.categories.map((e) => e.value),
        features: this.filterData.features.map((e) => e.value),
        collegeList: this.filterData.collegeList.map((e) => e.name),
        newCollege: this.filterData.newCollege.map((e) => e.value),
        majorList:
          this.majorFilterData.keyword.length > 0
            ? this.majorFilterData.majorList
              .map((e) => e.name)
              .concat([this.majorFilterData.keyword])
              .concat(this.userEvaluation.map((e) => e))
            : this.majorFilterData.majorList
              .map((e) => e.name)
              .concat(this.userEvaluation.map((e) => e)),
        majorType: this.majorFilterData.majorType.map((e) => e.name),
        newMajor: this.majorFilterData.newMajor.map((e) => e.value),
        cost: this.majorFilterData.cost.map((e) => e.value),
        jobList: this.jobFilterData.jobList.map((e) => e.id),
        chooseSubject: this.chooseSubjectData,
        pcId: this.$route.query.id,
        minScore: this.sliderValue[0],
        maxScore: this.sliderValue[1],
      };
      this.$store.commit('setFill', planList);
      console.log(planList, '====setFillData', this.filterDataArr);
      const { path, query } = this.$router.currentRoute;
      this.$router.push({
        path: '/accounts/oneFilling',
        query: {
          grade: query.grade,
          course: query.courseBack,
        },
      });
    },
    //高级筛选
    highFilter(e, name) {
      console.log(e, '===高级筛选', name);
      this.chooseSubjectData = this.chooseSubject;
      console.log('===高级筛选==', this.chooseSubject);
    },
  },
};
</script>

<style lang="scss" scoped>
.canvas-wrapper {
  position: relative;
  margin-top: 50px;
  height: 350px;

  #image {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 154px;
    height: 154px;
    cursor: pointer;
    z-index: 200;
  }
}

.text-999 {
  color: #999;
}

.major-active {
  color: #910000;
  border: 1px solid #910000;
  padding: 4px;
  border-radius: 4px;
}

.user-info {
  position: absolute;
  right: 0;
  top: 20px;
  font-size: 12px;
  color: #4a4a4a;
  letter-spacing: 0;
  line-height: 18px;
  z-index: 2;
}

.filter-list {
  // border-bottom: 1px dashed #e5e5e5;
  // display: -webkit-box;
  // display: -ms-flexbox;
  // display: flex;
  // -webkit-box-align: start;
  // -ms-flex-align: start;
  // align-items: flex-start;
  padding: 15px 6px 8px 15px;

  .filter-list-title {
    line-height: 20px;
    font-size: 16px;
    color: #212121;
    font-weight: 700;
    padding-bottom: 10px;
  }

  .filter-list-tags {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;

    .tag {
      width: 25%;
      text-align: center;
      height: 36px;
      border: none;
      -webkit-box-shadow: none;
      box-shadow: none;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      margin-bottom: 10px;

      .tag_box {
        -webkit-transition: 0.2s ease-in-out;
        transition: 0.2s ease-in-out;
        width: 100%;
        border: 1px solid transparent;
        font-size: 14px;
        color: #666;
        border-radius: 4px;
        margin-right: 8px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background-color: #f2f2f2;
        position: relative;
        overflow: hidden;
      }

      .small {
        cursor: pointer;
        margin-bottom: 10px;
        color: #666;
        float: left;
      }

      .tag_icon {
        border: 1px solid #910000;
        position: absolute;
        bottom: -2px;
        right: -2px;
        border-radius: 4px 0 4px 0;
        background: #910000;
        color: #fff;
        font-size: 14px;
      }
    }

    .active.tag_box {
      color: #910000;
      border: 1px solid #910000;
      background: #fff;
    }
  }

  /deep/ .el-input--prefix .el-input__inner {
    line-height: 40px !important;
    height: 40px !important;
  }
}

.fill_tabs_box {
  .el-tabs__content {
    padding: 0 0 15px;
  }

  .van-dropdown-menu {
    font-size: 12px;
    font-weight: 800;
  }

  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border-bottom: none;
  }

  .search_box {
    padding: 0 15px;

    .el-autocomplete {
      width: 100%;
    }

    /deep/ .el-input--prefix .el-input__inner {
      border-radius: 20px;
      background: #f8f8f8;
    }
  }

  .search_box1 {
    /deep/ .el-input.el-input--suffix {
      line-height: 40px !important;
      height: 40px !important;
    }
  }

  .filter-action {
    display: flex;
    padding: 0 20px 15px;

    .van-button {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      background-color: #910000;
      border-color: #910000;
      height: 40px;
      border-radius: 50px;
    }
  }

  .fill_tabs_box_tags {
    display: flex;
    justify-content: space-between;

    .van-sidebar {
      width: 110px;
      overflow-y: auto;
      height: 39vh;
    }

    .right_box {
      width: calc(100vw - 110px);
      overflow-y: auto;
      height: 39vh;

      .filter-list-tags {
        padding: 10px 15px;
      }

      .filter-list-tags1 {
        .tag1_title {
          font-size: 14px;
          padding: 0 15px 10px;
          font-weight: bold;
          color: #333;
        }

        .active1 {
          color: #910000;
        }

        .tag {
          width: auto;
        }
      }
    }
  }
}

.myFilterRecordBlockRow {
  overflow: hidden;
  height: auto;
  -webkit-transition: all 2s ease-in-out;
  transition: all 2s ease-in-out;

  .fill_box_title {
    padding: 0 15px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    line-height: 18px;
    margin-bottom: 10px;
  }

  .customer-selected-tags {
    padding-left: 5px;
    margin-right: 25px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;

    .tag {
      position: relative;
      padding: 4px 8px 4px 12px;
      background: #fff;
      border-radius: 13px;
      border: 1px solid #999;
      text-align: center;
      margin-left: 8px;
      margin-bottom: 8px;
      font-size: 12px;
      font-weight: 500;
      color: #9b9b9b;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      -ms-flex-direction: row;
      flex-direction: row;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;

      .el-icon-close {
        vertical-align: middle;
        padding-left: 5px;
      }
    }
  }
}

.middle {
  .el-tabs--card>.el-tabs__header {
    border-bottom: 1px solid #910000;
  }

  .el-tabs__item.is-active {
    color: #fff;
  }

  .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background: #910000;
    color: #fff;
    border-radius: 4px 4px 0 0;

    .el-dropdown {
      color: #ffffff;
    }
  }

  .el-tabs--card>.el-tabs__header .el-tabs__item {
    border: none;
    font-size: 16px;
    padding: 0 33px !important;
  }

  .el-tabs--card>.el-tabs__header .el-tabs__nav {
    border: none;
  }

  .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #910000;
  }

  .el-table .descending .sort-caret.descending {
    border-top-color: #910000;
  }

  .score-range-wrapper {
    position: absolute;
    right: 0;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;

    .score-range {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: flex-end;

      .slider {
        width: 420px;
      }

      .el-slider__bar {
        background: #910000;
      }

      .el-slider__button {
        border: 1px solid #910000;
        background: #910000;
      }
    }
  }

  .table-content {
    .el-table th>.cell {
      display: flex;
      align-items: center;
    }

    .customHeader {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .table-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      a {
        cursor: pointer;
        color: #333333;
      }

      a:hover {
        color: #910000;
      }

      .tag {
        border-radius: 3px;
        color: #fff;
        padding: 4px;
        line-height: 24px;
        font-size: 12px;
      }
    }
  }
}

.p-10 {
  padding: 10px;
}

.color9b {
  color: #9b9b9b;
}

//}

.intelligent {
  .compare-pop {
    height: 80%;
    position: fixed;
    right: -366px;
    top: 120px;
    -webkit-transition: -webkit-transform 1s;
    transition: -webkit-transform 1s;
    transition: transform 1s;
    transition: transform 1s, -webkit-transform 1s;
    z-index: 1001;

    .fold-box {
      width: 366px;
      padding: 10px 15px;
      background-color: #fff;
      border: 1px solid #ccc;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      position: relative;

      .compare-cart {
        position: absolute;
        left: -42px;
        top: -1px;

        .fold-btn {
          width: 42px;
          height: 206px;
          cursor: pointer;
          color: #fff;
          border-top-left-radius: 4px;
          background: #910000;

          .fold-text {
            width: 42px;
            height: 170px;
            -webkit-writing-mode: tb-rl;
            -ms-writing-mode: tb-rl;
            writing-mode: tb-rl;
            text-align: left;
            padding: 25px 13px 0;
            line-height: 20px;
            letter-spacing: 13px;
          }

          .compare-num {
            text-align: center;
          }
        }

        .save {
          background-color: #fff;
          color: #910000;
          font-size: 14px;
          width: 42px;
          height: 42px;
          border: 1px solid #910000;
        }

        .safe {
          border-bottom-left-radius: 4px;
        }
      }

      .compare-list {
        .compare-list-content {
          height: 630px;
          overflow: auto;
          width: 100%;
        }

        .compare-list-item {
          padding: 10px 0;
          border-bottom: 1px solid #e9e7e7;

          .compare-list-item-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .index {
            width: 24px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            border-radius: 4px;
            background-color: #910000;
            color: #fff;
            margin-right: 10px;
          }

          .title {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }

      .roll {
        height: 420px;
        overflow-x: hidden;
        overflow-y: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;

        /deep/ .is-checked {
          .el-checkbox__label {
            color: #910000 !important;
          }
        }
      }

      .compare-li {
        width: 332px;
        height: 60px;
        line-height: 60px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        border-bottom: 1px solid #e9e7e7;
      }
    }

    .el-button--default {
      background-color: #910000 !important;
      color: #fff !important;
      border: none;
      width: 335px;
      height: 40px;
    }
  }

  .info {
    .el-tabs--card>.el-tabs__header {
      border-bottom: 1px solid #910000;
    }

    .el-tabs__item.is-active {
      color: #fff;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
      background: #910000;
      border-radius: 4px 4px 0 0;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__item {
      border: none;
      font-size: 16px;
      padding: 0 33px !important;
    }

    .el-tabs--card>.el-tabs__header .el-tabs__nav {
      border: none;
    }

    .duibi-btn {
      text-align: center;
      width: 76px;
      height: 32px;
      line-height: 8px;
      position: absolute;
      right: 3px;
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      border: 1px solid #910000;
      color: #910000;
      padding: 8px 18px;
    }

    .duibi-added {
      text-align: center;
      width: 76px;
      height: 32px;
      line-height: 8px;
      position: absolute;
      right: 3px;
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      border: 1px solid #910000;
      background-color: #910000 !important;
      color: #fff;
    }

    .el-button.is-plain:focus,
    .el-button.is-plain:hover {
      background: #910000;
      border-color: #910000;
      color: #fff;
    }
  }

  .el-tag {
    height: 16px;
    line-height: 14px;
    font-size: 12px;
    margin-right: 10px;
    border-radius: 4px;
    padding: 0 2px;
  }

  .el-input-group__append {
    background-color: #910000;
    color: #fff;
    border-radius: 0 4px 4px 0;
    border: none;
  }
}

.fixed-title {
  width: 100%;
  position: fixed;
  top: 45px;
  /* left: 0; */
  z-index: 2000;
}

.foot-box {
  position: fixed;
  bottom: 0;
  left: 0;
  padding-left: 0;
}

.text-flex {
  width: 143px;
}

.foot-box {
  z-index: 44;
  width: 100%;
  height: 60px;
  padding-left: 15px;
  padding-right: 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #fff;
  border-top: 1px solid #ddd;
}

.foot-box .open,
.foot-box button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #910000;
  border-color: #910000;
  height: 40px;
}

.foot-box .open {
  width: 32%;
  height: 40px;
  border-radius: 4px;
}

.foot-box .text-flex {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.foot-box .foot-box-a {
  width: 32%;
  padding-left: 30px;
}

.foot-box .recommendBtn-flex {
  -webkit-box-flex: 2;
  -ms-flex: 2;
  flex: 2;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.foot-box .recommendBtn-flex .recommendBtn {
  float: left !important;
  width: 60% !important;
}

.foot-box .recommendBtn-flex .recommend-btn {
  float: left !important;
  width: 80% !important;
}

.foot-box .recommendBtn-flex-flex {
  -webkit-box-flex: 2;
  -ms-flex: 2;
  flex: 2;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding-right: 15px;
}

.foot-box .recommendBtn-flex-flex .recommendBtn {
  float: left !important;
  width: 60% !important;
}

.foot-box .recommendBtn-flex-flex .recommend-btn {
  float: left !important;
  width: 80% !important;
  border-radius: 20px;
}

.info {
  display: flex;
  position: absolute;
  top: 0;
  left: 15px;
  height: 55px;
  align-items: center;
  z-index: 99;

  .back {
    color: #333;
    font-size: 22px;
    font-weight: 600;
    margin-right: 8px;
  }
}

.page {
  min-height: 100vh;
  background: #fff;
}

.tabs {
  /deep/ .el-tabs__header {
    height: 55px;
    margin: 0;
    line-height: 55px;
    padding-left: 30px;
  }

  /deep/ .el-tabs__nav {
    // display: inline-flex;
    height: 52px;
    // justify-content: space-evenly;
    width: 100%;
  }

  /deep/ .el-tabs__item {
    font-size: 18px !important;
    font-weight: 700 !important;
    text-align: center;
    line-height: 55px;
    padding: 0 15px !important;
  }

  /deep/ .el-tabs__item.is-active {
    color: #910000 !important;
  }

  /deep/ .el-tabs__active-bar {
    background-color: #910000;
    border-radius: 5px;
    width: 75px !important;
    margin-left: 7px;
    height: 3px;
  }

  /deep/ .el-tabs__nav-wrap::after {
    height: 0px !important;
  }
}

.job {

  /deep/ .van-dropdown-menu__item:nth-child(2),
  /deep/ .van-dropdown-menu__item:nth-child(3) {
    .van-dropdown-menu__title::after {
      display: none;
    }
  }
}

/deep/ .van-dropdown-menu__title--active {
  color: #910000;
}

.score-range-wrapper {
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  width: 100vw;
  padding: 20px 0;
  font-size: 14px;
  background: #fff;

  .vue-slider-rail {
    background: #f0f0f0;
  }

  .score-box {
    display: flex;
    align-items: center;
    width: 100vw;
    padding: 0 15px;
    font-size: 16px;

    span {
      font-weight: 800;
    }

    .is-checked {
      /deep/ .el-checkbox__label {
        color: #910000 !important;
      }

      /deep/ .el-checkbox__inner {
        border: 1px solid #910000;
        background: #910000;
      }
    }

    .vue-slider-dot {
      height: auto !important;
    }

    .el-slider__button-wrapper {
      z-index: 2;
    }
  }

  .score-box1 {
    padding-bottom: 15px;
  }

  .score-range {
    // display: -webkit-box;
    // display: -ms-flexbox;
    // display: flex;
    // -webkit-box-align: center;
    // -ms-flex-align: center;
    // align-items: center;
    // -webkit-box-pack: end;
    // -ms-flex-pack: end;
    // justify-content: flex-end;
    width: 100vw;

    .slider {
      width: 59vw;
    }

    /deep/ .el-slider__bar {
      background: #910000;
    }

    /deep/ .el-slider__button {
      border: 1px solid #910000;
      background: #910000;
    }
  }
}
</style>
